/**
 * Map raw LifeBeacon API order status to user-facing display value.
 * "Hold" and "pending" are shown as "PENDING" to customers.
 */
export function mapOrderStatusForDisplay(raw: string | null | undefined): string {
  if (!raw) return 'PENDING';
  const lower = raw.toLowerCase();
  return (lower === 'hold' || lower === 'pending') ? 'PENDING' : raw;
}
